import $ from 'jquery';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/tooltip';
export var closeButton = function closeButton() {
  var tooltipButton = document.querySelectorAll('button[data-toggle*="tooltip"]');
  [].forEach.call(tooltipButton, function (ele) {
    var tooltipContent = ele.getAttribute('title');
    var closeText = ele.dataset.closeText;
    var buttonCode = "<p class='tooltip-close'><button class='btn btn-close'>".concat(closeText, "<span class='btn-close-x'>\xD7</span></button></p>");
    ele.setAttribute('title', tooltipContent + buttonCode);
  });
};
export default (function () {
  var defaultWhiteList = $.fn.tooltip.Constructor.Default.whiteList;
  defaultWhiteList.button = [];
  closeButton();
  $('[data-toggle="tooltip"]').tooltip({
    html: true,
    trigger: 'click hover focus'
  }).on('shown.bs.tooltip', function () {
    $('.tooltip-close .btn-close').on('click', function (e) {
      $(e.currentTarget).closest('.tooltip').tooltip('hide');
    });
  });
});